<template>
    <div class="" data-cy="container_serial_detail">
        <div class="relative mb-2">
            <div class="absolute -bottom-10 left-0 right-0 m-auto">
                <div class="box-img">
                    <img class="campaign-image" :src="serialModel.campaignImgUrl">
                    <!-- <div :style="{'background-image': `url('${serialModel.campaignImgUrl}')`}"></div> -->
                </div>
            </div>
        </div>
        <div class="">
            <div class="text-center text-18 text-a-blue-2140a6 font-bold px-5 pt-24" data-cy="text_serial_campaign_name">
                {{serialModel.campaignName}}
            </div>
            <div class="text-center underline text-16 text-a-gray-666666 mt-0.5 mb-3.5" data-cy="btn_serial_detail" @click="clickDetail('detail')">{{lbl.serial.detail}}</div>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "SerialDetail",
    mixins: [LocaleMixin],
    props: {
        serialModel: Object,
    },
    methods: {
        clickDetail: function(detail) {
            if (detail) {
               this.$emit('clickDetail',detail);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/image.scss";
    .campaign-image {
        div {
            @include boxRatio(80%);
        }
    }
    .box-img {
        width: 195px;
        height: 130px;
        img {
          border-radius: 8px;
        }

        margin: -40px auto;

    }
</style>
